import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { ProductConsumer } from '../context';
import './Product.css';


class Product extends Component {
    render() {
        const {id, make, title, image, disc, price, inCart} = this.props.products;
        return (
            <ProductConsumer> 
            {value => (
                <div className="col-sm-3 col-md-6 col-lg-3 mx-sm-1 mx-md-3 my-3">
                    <div className="card" style={{ width: '18rem' }}>
                        <div className="card-img-top" alt="...">
                            <Link to='/product/detail' onClick={()=>value.handleDetail(id)}>
                                <img src={image} alt="" className="img-fluid p-3"/>
                            </Link>
                        </div>
                        <div className="card-body">
                            <h5 className="card-make">{make}</h5>
                            <h1 className="title">{title}</h1>
                            <p className="card-text">{disc}</p>
                            <div className="cardbottom d-flex flex-row">
                                <div className="mr-auto">
                                <h5 className="price">Price: ${price}.00</h5>
                                </div>
                                <div className="ml-auto mt-auto">
                                <i class="fas fa-heart"></i>
                                <i className="fas fa-shopping-cart pl-2"
                                onClick={()=>{
                                value.addToCart(id);
                                // value.openModal(id);
                                }}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )} 
            </ProductConsumer>
        );
    }
}

export default Product;
